<div (mouseLeave)="closeMenuContextHandler($any($event))" class="action-button-group">
  @if (openPdfFlag) {
    <button
      (click)="openPdfButtonClickedHandler($event)"
      [appContextMenu]="openPdfMenuContextLines"
      [attr.aria-label]="openPdfLabel"
      [disabled]="openPdfDisabledFlag || (multipleActionFlag && !hasSelectedElementFlag)"
      [matTooltip]="openPdfLabel"
      data-testid="open-pdf-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_pdf"></mat-icon>
      @if (facturXFlag) {
        <mat-icon class="factur-x-badge" svgIcon="svg_factur_x"></mat-icon>
      }
      <span class="smart-action-button-label">{{ openPdfLabel }}</span>
    </button>
  }
  @if (multiplePreviewFlag) {
    <button
      (click)="multiplePreviewButtonClickedHandler($event)"
      [attr.aria-label]="multiplePreviewLabel"
      [disabled]="multipleActionFlag && !hasSelectedElementFlag"
      [matTooltip]="multiplePreviewLabel"
      data-testid="multiple-preview-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_multiple_preview"></mat-icon>
      <span class="smart-action-button-label">{{ multiplePreviewLabel }}</span>
    </button>
  }
  @if (downloadFecFlag) {
    <button
      (click)="downloadFecLabelButtonClickedHandler($event)"
      [attr.aria-label]="downloadFecLabel"
      [disabled]="multipleActionFlag && !hasSelectedElementFlag"
      [matTooltip]="downloadFecLabel"
      data-testid="download-fec-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_pdf_download"></mat-icon>
      <span class="smart-action-button-label">{{ downloadFecLabel }}</span>
    </button>
  }
  @if (downloadPdfFlag) {
    <button
      (click)="downloadPdfLabelButtonClickedHandler($event)"
      [appContextMenu]="downloadPdfMenuContextLines"
      [attr.aria-label]="downloadPdfLabel"
      [disabled]="downloadPdfDisabledFlag || (multipleActionFlag && !hasSelectedElementFlag)"
      [matTooltip]="downloadPdfLabel"
      data-testid="download-pdf-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_pdf_download"></mat-icon>
      @if (facturXFlag) {
        <mat-icon class="factur-x-badge" data-testid="facturx-badge-on-pdf-button" svgIcon="svg_factur_x"></mat-icon>
      }
      <span class="smart-action-button-label">{{ downloadPdfLabel }}</span>
    </button>
  }
  @if (downloadSpreadsheetFlag) {
    <button
      (click)="downloadSpreadsheetLabelButtonClickedHandler($event)"
      [attr.aria-label]="downloadSpreadsheetLabel"
      [matTooltip]="downloadSpreadsheetLabel"
      data-testid="download-spreadsheet-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_pdf_download"></mat-icon>
      <span class="smart-action-button-label">{{ downloadSpreadsheetLabel }}</span>
    </button>
  }
  @if (generateMultiplePdfFlag) {
    <button
      (click)="generateMultiplePdfButtonClickedHandler($event)"
      [appContextMenu]="generateMultiplePdfMenuContextLines"
      [attr.aria-label]="generateMultiplePdfLabel"
      [disabled]="multipleActionFlag && !hasSelectedElementFlag"
      [matTooltip]="generateMultiplePdfLabel"
      data-testid="download-multiple-pdf-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_pdf_multiple"></mat-icon>
      <span class="smart-action-button-label">{{ generateMultiplePdfLabel }}</span>
    </button>
  }
  @if (downloadZipFlag) {
    <button
      (click)="downloadZipLabelButtonClickedHandler($event)"
      [attr.aria-label]="downloadZipLabel"
      [disabled]="downloadZipDisabledFlag || (multipleActionFlag && !hasSelectedElementFlag)"
      [matTooltip]="downloadZipLabel"
      data-testid="download-zip-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_zip"></mat-icon>
      @if (downloadZipFacturXBadgeFlag) {
        <mat-icon class="factur-x-badge" svgIcon="svg_factur_x"></mat-icon>
      }
      @if (downloadZipUblBadgeFlag) {
        <mat-icon class="factur-x-badge" svgIcon="svg_ubl"></mat-icon>
      }
      <span class="smart-action-button-label">{{ downloadZipLabel }}</span>
    </button>
  }
  @if (downloadUblFlag) {
    <button
      (click)="downloadUblButtonClickedHandler($event)"
      [attr.aria-label]="downloadUblLabel"
      [disabled]="downloadUblDisabledFlag || (multipleActionFlag && !hasSelectedElementFlag)"
      [matTooltip]="downloadUblLabel"
      data-testid="download-ubl-button"
      mat-icon-button
    >
      <mat-icon svgIcon="svg_pdf_download"></mat-icon>
      <mat-icon class="factur-x-badge" svgIcon="svg_ubl"></mat-icon>
      <span class="smart-action-button-label">{{ downloadUblLabel }}</span>
    </button>
  }
</div>
